import { useTheme } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import Info from 'hb-react/shared/icons/Info';

export const Notice = ({
  notice,
  children = null,
  mt = 2,
  mb = 0,
  type = 'danger',
  ...props
}) => {
  const {
    colors: { fire, primary },
  } = useTheme();

  const fill = type === 'danger' ? fire : primary;

  return (
    <Box alignItems="center" mt={mt} mb={mb} {...props}>
      <Box mr={3} flexShrink={0}>
        <Info width={20} height={20} fill={fill} />
      </Box>
      {notice}
      {children}
    </Box>
  );
};
